import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '20% 80%',
    gridTemplateRows: '100%',
    gridTemplateAreas: "'filters main'",
    marginTop: 48,
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
  titleContainer: {
    width: '100%',
    paddingLeft: 16,
    paddingRight: 16,
    marginBottom: 8,
    marginTop: 8,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  main: {
    gridArea: 'main',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  staffDimensioning: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 48,
    backgroundColor: theme.palette.background.paper,
  },
  cardsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '8px 16px',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      height: 6,
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 4px #9DA5B1',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#9DA5B1',
      borderRadius: 3,
    },
  },
  chartAndTableContainer: {
    width: '100%',
    height: 300,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 8,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      height: '100%',
    },
  },
  chartContainer: {
    width: '100%',
    paddingLeft: 16,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  divider: {
    width: '100%',
  },
  tableContainer: {
    width: '40%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 32,
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 4px #9DA5B1',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#9DA5B1',
      borderRadius: 3,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 8,
      marginRight: 0,
    },
  },
  tableSubtitle: {
    width: '100%',
    marginBottom: 8,
    [theme.breakpoints.down('sm')]: {
      marginTop: 8,
    },
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  cell: {
    border: 'none',
  },
  bottomContentContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  scheduleContainer: {
    width: '100%',
  },
  donutContainer: {
    height: '100%',
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 32,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: 32,
      marginBottom: 64,
      marginRight: 0,
    },
  },
  loadingMargin: {
    marginLeft: 16,
  },
  bottomNavigation: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 99999,
    backgroundColor: theme.palette.primary.main,
  },
  bottomNavLabel: {
    color: theme.palette.common.white,
  },
}));
